import {fetchAllListPages} from '../../../service/listPagination'
import React, { useEffect, useState } from 'react'
import { useSubheader } from '../../../../_metronic/layout'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import { useHistory, Link } from 'react-router-dom'
import { baseURL } from '../../../service/API'
import axios from 'axios'
import { TextField } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import Swal from 'sweetalert2'
import { apiMessage } from '../../../service/apiError'
import { userPatch, canAssignUserRole, hasAction } from '../../../service/permissions'
import { roleCheck } from '../../../service/role'
import '../component.css'

export const EditUser = (props) => {
  const intl = useIntl()
  const subheader = useSubheader()
  const history = useHistory()
  const { authToken } = useSelector(state => state.auth)
  const id = new URLSearchParams(props.location.search).get('id') || props.location.state?.row?.id
  const [original, setOriginal] = useState(null)
  const [canViewPii, setCanViewPii] = useState(false)
  const [role, setRole] = useState(null)
  const [roles, setRoles] = useState([])
  const [canAssignRole, setCanAssignRole] = useState(false)
  const [error, setError] = useState('')
  subheader.setTitle(intl.formatMessage({ id: '109006', defaultMessage: 'Edit User management' }))

  useEffect(() => {
    let active = true
    // Old versions cached full edit rows. Keep only the ID and fetch the current representation.
    localStorage.removeItem('edit')
    if (!id) {
      setError('กรุณาเลือกผู้ใช้จากหน้ารายการ')
      return () => { active = false }
    }
    const headers = { Authorization: `Bearer ${authToken}` }
    Promise.all([
      axios.get(`${baseURL}/api/v1/user/view/${encodeURIComponent(id)}`, { headers }),
      fetchAllListPages(`${baseURL}/api/v1/user/roles`, { headers }),
      roleCheck('USER'), roleCheck('ROLE'),
    ]).then(([detail, options, userTypes, roleTypes]) => {
      if (!active) return
      if (!hasAction(userTypes, 'EDIT')) {
        setError('ไม่มีสิทธิ์แก้ไขผู้ใช้')
        return
      }
      const row = detail.data.data
      setOriginal(row)
      setCanAssignRole(canAssignUserRole(userTypes, roleTypes))
      setCanViewPii((detail.data._pii || row._pii)?.visible === true)
      setRoles(options.data.data)
      setRole(options.data.data.find(item => String(item.id) === String(row.role_id)) || null)
    }).catch(err => {
      if (!active) return
      setOriginal(null)
      setError(apiMessage(err, 'โหลดข้อมูลผู้ใช้ไม่สำเร็จ'))
    })
    return () => { active = false }
  }, [id, authToken])

  const handleSubmit = async (values, { setSubmitting }) => {
    if (!role) {
      setSubmitting(false)
      return Swal.fire('', 'กรุณาเลือก Role', 'warning')
    }
    const data = userPatch(original, values, canAssignRole ? role.id : original.role_id, canViewPii)
    if (!Object.keys(data).length) {
      setSubmitting(false)
      return Swal.fire('', 'ไม่มีข้อมูลที่เปลี่ยนแปลง', 'info')
    }
    try {
      await axios.put(`${baseURL}/api/v1/user/edit/${encodeURIComponent(id)}`, data, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      await Swal.fire('', intl.formatMessage({ id: '113102', defaultMessage: 'Update user success' }), 'success')
      history.push('/User')
    } catch (err) {
      await Swal.fire('', apiMessage(err, 'แก้ไขผู้ใช้ไม่สำเร็จ กรุณาตรวจสอบข้อมูลแล้วลองใหม่'), 'error')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Card>
      <CardHeader title={intl.formatMessage({ id: '109006', defaultMessage: 'Edit User management' })} />
      <CardBody>
        {error && <div className="alert alert-danger" role="alert">{error}</div>}
        {!original && !error && <p role="status">กำลังโหลดข้อมูล...</p>}
        {original && <Formik
          initialValues={{ firstname: original.firstname ?? '', lastname: original.lastname ?? '', email: original.email ?? '' }}
          validate={values => {
            const errors = {}
            if (canViewPii) {
              if (!values.firstname) errors.firstname = 'Firstname is required'
              if (!values.lastname) errors.lastname = 'Lastname is required'
              if (!values.email) errors.email = 'Email is required'
            }
            return errors
          }}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => <Form>
            {!canViewPii && <p className="alert alert-info">ข้อมูลส่วนบุคคลถูกปิดบังตามสิทธิ์ของคุณ การแก้ไข Role จะไม่เปลี่ยนข้อมูลเหล่านี้</p>}
            {[
              ['firstname', '109007', 'Firstname'],
              ['lastname', '109009', 'Lastname'],
              ['email', '109011', 'Email'],
            ].map(([name, messageId, label]) => <div key={name} className="form-inline mb-5">
              <label htmlFor={`edit-user-${name}`} style={{ width: '20%', justifyContent: 'flex-start' }}>
                {intl.formatMessage({ id: messageId, defaultMessage: label })} :
              </label>
              <Field id={`edit-user-${name}`} name={name} type="text" className="form-control"
                disabled={!canViewPii || isSubmitting}
                style={{ height: 38, width: 530, backgroundColor: '#F4F6F9', borderRadius: 5, borderWidth: 0 }} />
              <ErrorMessage name={name}>{message => <div className="text-danger ml-3">{message}</div>}</ErrorMessage>
            </div>)}
            <div className="form-inline mb-5">
              <label htmlFor="edit-user-role" style={{ width: '20%', justifyContent: 'flex-start' }}>Role :</label>
              <Autocomplete id="edit-user-role" options={roles} value={role} disabled={!canAssignRole || isSubmitting}
                getOptionLabel={option => option.role || ''}
                getOptionSelected={(option, value) => option.id === value.id}
                onChange={(event, value) => setRole(value)}
                style={{ width: 530, backgroundColor: '#F4F6F9', borderRadius: 5 }}
                renderInput={params => <TextField {...params} variant="outlined" />} />
            </div>
            <button type="submit" className="btn btn-primary mr-3" disabled={isSubmitting || (!canViewPii && !canAssignRole)}>
              {isSubmitting ? 'กำลังบันทึก...' : intl.formatMessage({ id: '113101', defaultMessage: 'Save' })}
            </button>
            <Link to="/User" className="btn btn-secondary">ยกเลิก</Link>
          </Form>}
        </Formik>}
        {error && <Link to="/User" className="btn btn-secondary">กลับหน้ารายการ</Link>}
      </CardBody>
    </Card>
  )
}
